module.exports = __webpack_public_path__ + "files/046c23f7a41b80a90837c7423a34ae90.png";